import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  SignedIntFormatterStructureuogj4y4pj858 as SignedIntFormatterStructure,
  UnsignedIntFormatterStructure2iqfxgv3d2ejy as UnsignedIntFormatterStructure,
  StringFormatterStructure3i97mc47fm0qc as StringFormatterStructure,
  DecimalFractionFormatterStructure2fby7dmyhkzn1 as DecimalFractionFormatterStructure,
} from './formatter/FormatterOperation.mjs';
import { SpacePaddedFormatter1bbtqhbgrvf8v as SpacePaddedFormatter } from './formatter/Formatter.mjs';
import {
  SignedIntParsergn6823y2nf4q as SignedIntParser,
  spaceAndZeroPaddedUnsignedInt3iec50j4qusnr as spaceAndZeroPaddedUnsignedInt,
  StringSetParserOperation82b6pl2fn98q as StringSetParserOperation,
  NumberSpanParserOperation3qyp02c4km7yu as NumberSpanParserOperation,
} from './parser/ParserOperation.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getOrNull1go7ef9ldk0df as getOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  listOfvhqybd2zx248 as listOf,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ParserStructure2cqp7gjft5io4 as ParserStructure } from './parser/Parser.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { FractionPartConsumerf0mxqojimz2s as FractionPartConsumer } from './parser/NumberConsumer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function Accessor$getterNotNull$ref(p0) {
  var l = (_this__u8e3s4) => p0.i20(_this__u8e3s4);
  l.callableName = 'getterNotNull';
  return l;
}
var SignedIntFieldFormatDirectiveClass;
function SignedIntFieldFormatDirective() {
  if (SignedIntFieldFormatDirectiveClass === VOID) {
    class $ {
      constructor(field, minDigits, maxDigits, spacePadding, outputPlusOnExceededWidth) {
        this.g1v_1 = field;
        this.h1v_1 = minDigits;
        this.i1v_1 = maxDigits;
        this.j1v_1 = spacePadding;
        this.k1v_1 = outputPlusOnExceededWidth;
        // Inline function 'kotlin.require' call
        if (!(this.h1v_1 == null || this.h1v_1 >= 0)) {
          var message = 'The minimum number of digits (' + this.h1v_1 + ') is negative';
          throw IllegalArgumentException().a1(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(this.i1v_1 == null || this.h1v_1 == null || this.i1v_1 >= this.h1v_1)) {
          var message_0 = 'The maximum number of digits (' + this.i1v_1 + ') is less than the minimum number of digits (' + this.h1v_1 + ')';
          throw IllegalArgumentException().a1(toString(message_0));
        }
      }
      l1v() {
        return this.g1v_1;
      }
      a1u() {
        var tmp = Accessor$getterNotNull$ref(this.g1v_1.j20());
        var tmp0_elvis_lhs = this.h1v_1;
        var formatter = new (SignedIntFormatterStructure())(tmp, tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs, this.k1v_1);
        return !(this.j1v_1 == null) ? new (SpacePaddedFormatter())(formatter, this.j1v_1) : formatter;
      }
      c1u() {
        return SignedIntParser(this.h1v_1, this.i1v_1, this.j1v_1, this.g1v_1.j20(), this.g1v_1.k20(), this.k1v_1);
      }
    }
    initMetadataForClass($, 'SignedIntFieldFormatDirective');
    SignedIntFieldFormatDirectiveClass = $;
  }
  return SignedIntFieldFormatDirectiveClass;
}
function Accessor$getterNotNull$ref_0(p0) {
  var l = (_this__u8e3s4) => p0.i20(_this__u8e3s4);
  l.callableName = 'getterNotNull';
  return l;
}
var UnsignedIntFieldFormatDirectiveClass;
function UnsignedIntFieldFormatDirective() {
  if (UnsignedIntFieldFormatDirectiveClass === VOID) {
    class $ {
      constructor(field, minDigits, spacePadding) {
        this.r1v_1 = field;
        this.s1v_1 = minDigits;
        this.t1v_1 = spacePadding;
        this.u1v_1 = this.r1v_1.r20_1;
        // Inline function 'kotlin.require' call
        if (!(this.s1v_1 >= 0)) {
          var message = 'The minimum number of digits (' + this.s1v_1 + ') is negative';
          throw IllegalArgumentException().a1(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(this.u1v_1 >= this.s1v_1)) {
          var message_0 = 'The maximum number of digits (' + this.u1v_1 + ') is less than the minimum number of digits (' + this.s1v_1 + ')';
          throw IllegalArgumentException().a1(toString(message_0));
        }
        if (!(this.t1v_1 == null)) {
          // Inline function 'kotlin.require' call
          if (!(this.t1v_1 > this.s1v_1)) {
            var message_1 = 'The space padding (' + this.t1v_1 + ') should be more than the minimum number of digits (' + this.s1v_1 + ')';
            throw IllegalArgumentException().a1(toString(message_1));
          }
        }
      }
      l1v() {
        return this.r1v_1;
      }
      a1u() {
        var formatter = new (UnsignedIntFormatterStructure())(Accessor$getterNotNull$ref_0(this.r1v_1.l20_1), this.s1v_1);
        return !(this.t1v_1 == null) ? new (SpacePaddedFormatter())(formatter, this.t1v_1) : formatter;
      }
      c1u() {
        return spaceAndZeroPaddedUnsignedInt(this.s1v_1, this.u1v_1, this.t1v_1, this.r1v_1.l20_1, this.r1v_1.o20_1);
      }
    }
    initMetadataForClass($, 'UnsignedIntFieldFormatDirective');
    UnsignedIntFieldFormatDirectiveClass = $;
  }
  return UnsignedIntFieldFormatDirectiveClass;
}
function getStringValue($this, target) {
  // Inline function 'kotlin.let' call
  var it = $this.z1v_1.l20_1.i20(target);
  var tmp0_elvis_lhs = getOrNull($this.a1w_1, it - $this.z1v_1.m20_1 | 0);
  return tmp0_elvis_lhs == null ? 'The value ' + it + ' of ' + $this.z1v_1.o20_1 + ' does not have a corresponding string representation' : tmp0_elvis_lhs;
}
var AssignableStringClass;
function AssignableString() {
  if (AssignableStringClass === VOID) {
    class $ {
      constructor($outer) {
        this.s20_1 = $outer;
      }
      t20(container, newValue) {
        var tmp0_safe_receiver = this.s20_1.z1v_1.l20_1.u20(container, this.s20_1.a1w_1.s1(newValue) + this.s20_1.z1v_1.m20_1 | 0);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = this.s20_1.a1w_1.q1(tmp0_safe_receiver - this.s20_1.z1v_1.m20_1 | 0);
        }
        return tmp;
      }
      u20(container, newValue) {
        var tmp = (container == null ? true : !(container == null)) ? container : THROW_CCE();
        return this.t20(tmp, (!(newValue == null) ? typeof newValue === 'string' : false) ? newValue : THROW_CCE());
      }
      k20() {
        return this.s20_1.b1w_1;
      }
    }
    initMetadataForClass($, 'AssignableString');
    AssignableStringClass = $;
  }
  return AssignableStringClass;
}
function NamedUnsignedIntFieldFormatDirective$getStringValue$ref(p0) {
  var l = (_this__u8e3s4) => {
    var tmp0 = p0;
    return getStringValue(tmp0, _this__u8e3s4);
  };
  l.callableName = 'getStringValue';
  return l;
}
var NamedUnsignedIntFieldFormatDirectiveClass;
function NamedUnsignedIntFieldFormatDirective() {
  if (NamedUnsignedIntFieldFormatDirectiveClass === VOID) {
    class $ {
      constructor(field, values, name) {
        this.z1v_1 = field;
        this.a1w_1 = values;
        this.b1w_1 = name;
        // Inline function 'kotlin.require' call
        if (!(this.a1w_1.p1() === ((this.z1v_1.n20_1 - this.z1v_1.m20_1 | 0) + 1 | 0))) {
          var message = 'The number of values (' + this.a1w_1.p1() + ') in ' + toString(this.a1w_1) + ' does not match the range of the field (' + ((this.z1v_1.n20_1 - this.z1v_1.m20_1 | 0) + 1 | 0) + ')';
          throw IllegalArgumentException().a1(toString(message));
        }
      }
      l1v() {
        return this.z1v_1;
      }
      a1u() {
        return new (StringFormatterStructure())(NamedUnsignedIntFieldFormatDirective$getStringValue$ref(this));
      }
      c1u() {
        return new (ParserStructure())(listOf(new (StringSetParserOperation())(this.a1w_1, new (AssignableString())(this), 'one of ' + toString(this.a1w_1) + ' for ' + this.b1w_1)), emptyList());
      }
    }
    initMetadataForClass($, 'NamedUnsignedIntFieldFormatDirective');
    NamedUnsignedIntFieldFormatDirectiveClass = $;
  }
  return NamedUnsignedIntFieldFormatDirectiveClass;
}
function getStringValue_0($this, target) {
  // Inline function 'kotlin.let' call
  var it = $this.g1y_1.j20().i20(target);
  var tmp0_elvis_lhs = $this.h1y_1.p3($this.g1y_1.j20().i20(target));
  return tmp0_elvis_lhs == null ? 'The value ' + toString_0(it) + ' of ' + $this.g1y_1.k20() + ' does not have a corresponding string representation' : tmp0_elvis_lhs;
}
var AssignableStringClass_0;
function AssignableString_0() {
  if (AssignableStringClass_0 === VOID) {
    class $ {
      constructor($outer) {
        this.v20_1 = $outer;
      }
      t20(container, newValue) {
        var tmp0_safe_receiver = this.v20_1.g1y_1.j20().u20(container, ensureNotNull(this.v20_1.j1y_1.p3(newValue)));
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = this.v20_1.h1y_1.p3(tmp0_safe_receiver);
        }
        return tmp;
      }
      u20(container, newValue) {
        var tmp = (container == null ? true : !(container == null)) ? container : THROW_CCE();
        return this.t20(tmp, (!(newValue == null) ? typeof newValue === 'string' : false) ? newValue : THROW_CCE());
      }
      k20() {
        return this.v20_1.i1y_1;
      }
    }
    initMetadataForClass($, 'AssignableString');
    AssignableStringClass_0 = $;
  }
  return AssignableStringClass_0;
}
function NamedEnumIntFieldFormatDirective$getStringValue$ref(p0) {
  var l = (_this__u8e3s4) => {
    var tmp0 = p0;
    return getStringValue_0(tmp0, _this__u8e3s4);
  };
  l.callableName = 'getStringValue';
  return l;
}
var NamedEnumIntFieldFormatDirectiveClass;
function NamedEnumIntFieldFormatDirective() {
  if (NamedEnumIntFieldFormatDirectiveClass === VOID) {
    class $ {
      constructor(field, mapping, name) {
        this.g1y_1 = field;
        this.h1y_1 = mapping;
        this.i1y_1 = name;
        var tmp = this;
        // Inline function 'kotlin.collections.associate' call
        var this_0 = this.h1y_1.d2();
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
        // Inline function 'kotlin.collections.associateTo' call
        var destination = LinkedHashMap().fc(capacity);
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          // Inline function 'kotlin.collections.plusAssign' call
          var pair = to(element.f2(), element.e2());
          destination.s3(pair.af_1, pair.bf_1);
        }
        tmp.j1y_1 = destination;
      }
      l1v() {
        return this.g1y_1;
      }
      a1u() {
        return new (StringFormatterStructure())(NamedEnumIntFieldFormatDirective$getStringValue$ref(this));
      }
      c1u() {
        return new (ParserStructure())(listOf(new (StringSetParserOperation())(this.h1y_1.r3(), new (AssignableString_0())(this), 'one of ' + toString(this.h1y_1.r3()) + ' for ' + this.i1y_1)), emptyList());
      }
    }
    initMetadataForClass($, 'NamedEnumIntFieldFormatDirective');
    NamedEnumIntFieldFormatDirectiveClass = $;
  }
  return NamedEnumIntFieldFormatDirectiveClass;
}
function Accessor$getterNotNull$ref_1(p0) {
  var l = (_this__u8e3s4) => p0.i20(_this__u8e3s4);
  l.callableName = 'getterNotNull';
  return l;
}
var DecimalFractionFieldFormatDirectiveClass;
function DecimalFractionFieldFormatDirective() {
  if (DecimalFractionFieldFormatDirectiveClass === VOID) {
    class $ {
      constructor(field, minDigits, maxDigits, zerosToAdd) {
        this.c1z_1 = field;
        this.d1z_1 = minDigits;
        this.e1z_1 = maxDigits;
        this.f1z_1 = zerosToAdd;
      }
      l1v() {
        return this.c1z_1;
      }
      a1u() {
        return new (DecimalFractionFormatterStructure())(Accessor$getterNotNull$ref_1(this.c1z_1.j20()), this.d1z_1, this.e1z_1, this.f1z_1);
      }
      c1u() {
        return new (ParserStructure())(listOf(new (NumberSpanParserOperation())(listOf(new (FractionPartConsumer())(this.d1z_1, this.e1z_1, this.c1z_1.j20(), this.c1z_1.k20())))), emptyList());
      }
    }
    initMetadataForClass($, 'DecimalFractionFieldFormatDirective');
    DecimalFractionFieldFormatDirectiveClass = $;
  }
  return DecimalFractionFieldFormatDirectiveClass;
}
//region block: exports
export {
  DecimalFractionFieldFormatDirective as DecimalFractionFieldFormatDirective1h9sbm886izzq,
  NamedEnumIntFieldFormatDirective as NamedEnumIntFieldFormatDirective2e2bgf4uj6a33,
  NamedUnsignedIntFieldFormatDirective as NamedUnsignedIntFieldFormatDirective1yq6ki9eqgm4v,
  SignedIntFieldFormatDirective as SignedIntFieldFormatDirective2ce7tjucbhgd2,
  UnsignedIntFieldFormatDirective as UnsignedIntFieldFormatDirective20kfpdbszyixg,
};
//endregion

//# sourceMappingURL=FieldFormatDirective.mjs.map
